import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Chúng ta sử dụng localStorage
import { combineReducers } from 'redux';
import cartReducer from './cartReducer';

// Cấu hình Redux Persist
const persistConfig = {
    key: 'root',  // Dữ liệu sẽ được lưu vào key "root"
    storage: storage,  // Sử dụng localStorage
};

const rootReducer = combineReducers({
    cart: cartReducer, // Tên key "cart" sẽ ánh xạ đến `cartReducer`
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Tạo store
const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { store, persistor };
